import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useLocale } from 'src/app/shared/hooks/l10n';
import { useSessionAsync } from 'src/app/shared/hooks/session';
import { isLoaded } from 'src/app/shared/utils/async';

import { useMembershipModalState } from '../../../../modalContext';

export function useLocalizedHeadline(): string {
	const [{ ppmuLocalizedHeadlineData }] = useMembershipModalState();
	const { translate, localizeNumber } = useI18n();
	const locale = useLocale();
	const session = useSessionAsync();

	const { headlineSuffix, name } = useMemo(() => {
		if (!isLoaded(session)) {
			return { headlineSuffix: '', name: '' };
		}

		const isGuest = session.value.loginState === 'GUEST';
		const shortDisplayName = session.value.user?.shortDisplayName ?? '';

		return {
			headlineSuffix: isGuest ? '_guest' : '',
			name: shortDisplayName,
		};
	}, [session]);

	if (!ppmuLocalizedHeadlineData) {
		return translate(`corgi.co.ppmu.modal.headline${headlineSuffix}`, { name });
	}

	const { totalSignatureCount, userCountryName, userStateName } = ppmuLocalizedHeadlineData;

	const shouldShowLocalizedHeadline = locale === 'en-US' && (userCountryName || userStateName);

	if (shouldShowLocalizedHeadline) {
		const location = userStateName ?? userCountryName;
		return `${localizeNumber(totalSignatureCount)} people in ${location} are using Change.org. Can you help keep it free for everyone?`;
	}

	return translate(`corgi.co.ppmu.modal.headline${headlineSuffix}`, { name });
}
